import { ReactNode } from 'react';

import classNames from 'classnames';

import { TextHighlight, TextHighlightColors } from '@/components/TextHighlight';
import {
  Typography,
  TypographyNameType,
  TypographyTagType,
} from '@/components/Typography';

export interface SectionHeadingProps {
  title?: ReactNode;
  highlight?: TextHighlightColors;
  titleTag?: TypographyTagType;
  titleName?: TypographyNameType;
  subtitle?: ReactNode;
  subtitleName?: TypographyNameType;
  noMargin?: boolean;
  variant?: 'big-serif' | 'pill';
}

export function SectionHeading({
  title,
  highlight,
  titleTag = 'h2',
  titleName = 'display-1400',
  subtitle,
  subtitleName = 'body-450',
  noMargin,
  variant = 'big-serif',
}: SectionHeadingProps) {
  return (
    <header
      className={classNames('flex flex-col gap-2', {
        'mb-6 md:mb-10': !noMargin && variant === 'big-serif',
        'mb-4 md:mb-6': !noMargin && variant === 'pill',
        'items-start': variant === 'pill',
      })}
    >
      {title && variant === 'big-serif' && (
        <Typography name={titleName} tag={titleTag}>
          {highlight ? (
            <TextHighlight color={highlight}>{title}</TextHighlight>
          ) : (
            title
          )}
        </Typography>
      )}
      {title && variant === 'pill' && (
        <Typography
          name="heading-400"
          tag={titleTag}
          className={classNames('rounded-full px-3 py-1', {
            'bg-cyan-300 text-black': highlight === 'cyan',
            'bg-magenta-300 text-black': highlight === 'magenta',
            'bg-yellow-500 text-black': highlight === 'yellow',
            'bg-green-200 text-black': highlight === 'green',
            'bg-gray-200 text-black': highlight === 'gray',
            'bg-blue-400 text-paper': highlight === 'blue',
            'bg-black text-paper': highlight === 'black',
            'bg-purple-100 text-black': highlight === 'purple',
          })}
        >
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography name={subtitleName} tag="p" className="text-secondary">
          {subtitle}
        </Typography>
      )}
    </header>
  );
}
